"use client";

import type { Dispatch, SetStateAction } from "react";
import { createContext, useState } from "react";

type BibleLanguageContextShape = {
  rtl: boolean;
  setRtl: Dispatch<SetStateAction<boolean>>;
};

export const BibleLanguageContext = createContext<BibleLanguageContextShape>({
  rtl: false,
  setRtl: () => {},
});

export const BibleLanguageProvider = ({ children }) => {
  const [rtl, setRtl] = useState<boolean>(false);

  return (
    <BibleLanguageContext.Provider value={{ rtl, setRtl }}>
      {children}
    </BibleLanguageContext.Provider>
  );
};
